
export const spaces = {
  0: "0px",
  0.5: "4px",
  1: "8px",
  1.5: "12px",
  2: "16px",
  2.5: "20px",
  3: "24px",
  3.5: "28px",
  4: "32px",
  5: "40px",
  6: "48px",
  7: "56px",
  8: "64px",
  9: "72px",
  10: "80px",
  11: "88px",
  12: "96px",
} as const;

export const spacesPercent = {
  0: "0%",
  25: "25%",
  50: "50%",
  100: "100%"
} as const;